import template from './template.html';
import './style.scss';

export class CandidateProfileStatusLabel {}

export const CandidateProfileStatusLabelConfiguration = {
    template,
    bindings: {
        workflowStatus: '<',
    },
    controller: CandidateProfileStatusLabel,
    controllerAs: 'candidateProfileStatusLabelCtrl',
};